<template>
  <section class="bodypad">
    <v-row class="mt-4">
      <div class="left-col">
        <header class="d-flex mb-8" style="gap: 1rem">
          <v-icon
            class="pa-2 rounded-pill"
            :style="`--element-color: ${
              bill.estado === 3 ? '#E8F5E9' : '#E3F2FD'
            }`"
            :color="
              bill.estado === 3 ? 'light-green darken-4' : 'blue darken-2'
            "
          >
            {{ bill.estado === 3 ? "check" : "history" }}
          </v-icon>
          <h1>Factura {{ bill.descripcion_estado?.toLowerCase() }}</h1>
        </header>

        <main class="d-flex flex-column" style="gap: 1.5rem">
          <div class="d-flex flex-column">
            <h6 class="font-weight-bold text-h6">Total de la factura</h6>
            <span class="text-subtitle-1">$ {{ bill.monto_factura }}</span>
          </div>

          <div v-if="bill?.monto_cobrado" class="d-flex flex-column">
            <h6 class="font-weight-bold text-h6">Monto cobrado</h6>
            <span class="text-subtitle-1"
              >${{ bill.monto_cobrado }} - Pagado</span
            >
            <!-- <span class="text-subtitle-1"
              >${{ bill.monto_cobrado }} - Cobrado el
              {{ bill?.fecha_monto_cobrado | formatDateShort }}</span
            > -->
          </div>

          <div v-if="bill.estado !== 3" class="d-flex flex-column">
            <h6 class="font-weight-bold text-h6">Monto a cobrar</h6>
            <span class="text-subtitle-1"
              >${{ bill.monto_a_cobrar }} - A cobrar el
              {{ bill?.fecha_monto_a_cobrar | formatDateShort }}</span
            >
          </div>

          <div>
            <h6 class="font-weight-bold text-h6">
              ¿En que cuenta lo voy a cobrar?
            </h6>
            <div class="d-flex flex-column">
              <span class="text-subtitle-1 font-weight-bold"
                >Nombre y Apellido:
                <span class="font-weight-regular"
                  >{{ bill.datos_facturacion?.nombre_prestador }}
                  {{ bill.datos_facturacion?.apellido_prestador }}</span
                ></span
              >
              <span class="text-subtitle-1 font-weight-bold"
                >CUIT:
                <span class="font-weight-regular">{{
                  bill.datos_facturacion?.cuit
                }}</span></span
              >
              <span class="text-subtitle-1 font-weight-bold"
                >Banco:
                <span class="font-weight-regular">{{
                  bill.datos_facturacion?.banco
                }}</span></span
              >
              <span class="text-subtitle-1 font-weight-bold"
                >CBU:
                <span class="font-weight-regular">{{
                  bill.datos_facturacion?.cbu
                }}</span></span
              >
            </div>
          </div>

          <div v-if="bill.transacciones?.length > 0">
            <h6 class="font-weight-bold text-h6">Servicios facturados</h6>

            <BillServiceCard
              v-for="transaction of bill.transacciones"
              :key="transaction.id"
              :transaction="transaction"
            />
          </div>

          <section class="d-flex flex-column" style="gap: 1.5rem">
            <div v-if="bill.archivo_comprobantes?.length > 0">
              <h6 class="font-weight-bold text-h6">Comprobantes de pago</h6>
              <ProofItem
                v-for="(
                  { file, filename, amount, proof_created_time }, index
                ) of bill.archivo_comprobantes"
                :key="index"
                :filename="filename"
                :createdTime="proof_created_time"
                :file="file"
                :amount="amount"
                show-amount
              />
            </div>

            <div v-if="bill.archivo_factura">
              <h6 class="font-weight-bold text-h6">Facturas asociada</h6>
              <ProofItem
                icon="image"
                :file="bill.archivo_factura"
                :filename="bill.filename"
                :amount="bill.monto_factura"
                :created-time="bill.created_time"
                show-amount
              />
            </div>
          </section>
        </main>
      </div>
    </v-row>
  </section>
</template>

<script>
import BillServiceCard from "../components/BillServiceCard.vue";
import ProofItem from "../components/ProofItem.vue";

export default {
  components: { BillServiceCard, ProofItem },
  props: ["bill"],
};
</script>

<style scoped>
@media (max-width: 959px) {
  .left-col {
    width: 100%;
  }
}

@media (min-width: 960px) {
  .left-col {
    width: 65%;
  }
}
.short-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bodypad {
  padding: 12px 24px 108px 24px;
}

.v-icon {
  background-color: var(--element-color);
}
</style>
